import { useEffect, useState } from 'react'
import { getPortaria, listPortaria, postPortaria } from './portariaApi'
import { residentApi } from './residentApi'
type Photo = { id: string; mediaType: string; dataBase64: string }
export function TicketPhotos({ clientId, ticketId, resident }: { clientId: string; ticketId: string; resident: boolean }) {
  const [photos, setPhotos] = useState<Photo[]>([])
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const path = `tickets/${ticketId}/photos`
  async function load() {
    const items = resident ? await residentApi<{ id: string }[]>(path) : await listPortaria<{ id: string }>(clientId, path)
    return Promise.all(items.map(item => resident ? residentApi<Photo>(`${path}/${item.id}`).then(photo => ({ ...photo, id: item.id })) : getPortaria<Photo>(clientId, `${path}/${item.id}`).then(photo => ({ ...photo, id: item.id }))))
  }
  useEffect(() => {
    let active = true
    setPhotos([])
    load().then(items => { if (active) setPhotos(items) }).catch(() => { if (active) setError('Não foi possível carregar as fotos.') })
    return () => { active = false }
  }, [clientId, ticketId, resident])
  async function upload(file: File) {
    if (!['image/jpeg', 'image/png'].includes(file.type) || file.size > 20 * 1024 * 1024) { setError('Selecione uma foto JPEG ou PNG de até 20 MB.'); return }
    setBusy(true); setError('')
    let bitmap: ImageBitmap | null = null
    try {
      bitmap = await createImageBitmap(file)
      const scale = Math.min(1, 1200 / Math.max(bitmap.width, bitmap.height))
      const canvas = document.createElement('canvas'); canvas.width = Math.round(bitmap.width * scale); canvas.height = Math.round(bitmap.height * scale)
      const context = canvas.getContext('2d'); if (!context) throw new Error('image_canvas_unavailable')
      context.drawImage(bitmap, 0, 0, canvas.width, canvas.height)
      const dataBase64 = canvas.toDataURL('image/jpeg', 0.75).split(',')[1]
      const body = { mediaType: 'image/jpeg', dataBase64 }
      if (resident) await residentApi(path, body, 'POST')
      else await postPortaria(clientId, path, body)
      setPhotos(await load())
    } catch { setError(bitmap ? 'Não foi possível enviar a foto. Confira a conexão e o limite de cinco fotos por chamado.' : 'Não foi possível ler esta imagem. Escolha outro arquivo JPEG ou PNG.') }
    finally { bitmap?.close(); setBusy(false) }
  }
  return <section><h4>Fotos do chamado</h4>{error && <p role="alert">{error}</p>}<div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>{photos.map(photo => <img key={photo.id} src={`data:${photo.mediaType};base64,${photo.dataBase64}`} alt="Foto anexada ao chamado" style={{ width: 180, maxWidth: '100%', height: 140, objectFit: 'contain', borderRadius: 12 }} />)}</div><label>Anexar foto<input type="file" accept="image/jpeg,image/png" disabled={busy || photos.length >= 5} onChange={event => { const file = event.target.files?.[0]; if (file) void upload(file); event.target.value = '' }} /></label>{busy && <p role="status">Enviando foto…</p>}</section>
}
